module.exports = __webpack_public_path__ + "img/check.182c799d.svg";